import { sanitizeText } from "../utils/index.js";
import { getAddressesFromInput } from "../utils/getAddressesFromInput.js";
export const selectCreateOrganizationCustomerInput = (customerInput) => {
    const { email, addresses, meta, ...customer } = customerInput;
    return {
        ...customer,
        addresses: getAddressesFromInput(addresses, email ?? undefined),
        email: email ? sanitizeText(email) : undefined,
        meta: meta?.filter((meta) => meta?.key && meta?.value) ?? [],
    };
};
